const cet = { standard: 'MEZ', dst: 'MESZ' };

export default {
  Europe: {
    Amsterdam: cet,
    Berlin: cet,
    Brussels: cet,
    Copenhagen: cet,
    Oslo: cet,
    Paris: cet,
    Stockholm: cet,
  },
};
